import { RegisterEmailVerificationState, registerEmailVerificationInitialState } from './State'

import { SET_IS_VERIFYING_EMAIL, SET_IS_VERIFIED, RESET, RegisterEmailVerificationAction } from './Actions'

function registerEmailVerificationReducer(
  state: RegisterEmailVerificationState,
  action: RegisterEmailVerificationAction
): RegisterEmailVerificationState {
  switch (action.type) {
    case SET_IS_VERIFYING_EMAIL:
      return Object.assign({}, state, { isVerifyingEmail: action.payload })
    case SET_IS_VERIFIED:
      return {
        ...state,
        isVerified: action.payload
      }
    case RESET:
      return registerEmailVerificationInitialState
    default:
      return state
  }
}

export default registerEmailVerificationReducer
